import { t } from '@/utils/i18n'
import productDefault from '@/assets/img/default/default.png'

const DEFAULT_TAB = [
  {
    categoryName: t('全部'),
    categoryId: 'all',
    categoryLevel: 0,
    children: null,
  },
  {
    categoryName: t('买过'),
    categoryId: 'bought',
    categoryLevel: 0,
    children: null,
  },
  {
    categoryName: t('推荐'),
    categoryId: 'recommend',
    categoryLevel: 0,
    children: [
      {
        categoryName: t('新品'),
        categoryId: 'new',
        categoryLevel: 0,
        children: null,
      },
      {
        categoryName: t('爆品'),
        categoryId: 'hot',
        categoryLevel: 0,
        children: null,
      },
      {
        categoryName: t('促销'),
        categoryId: 'promotion',
        categoryLevel: 0,
        children: null,
      },
    ],
  },
]

/**
 * 获取排序选项
 * @returns 
 */
function getSortOptions() {
  // 默认排序列表
  const SORT_OPTIONS = [
    {
      name: t('综合'),
      key: '3',
      hideDirection: true, // 隐藏上下箭头
      cloudProductSort: [1], // 默认显示排序
    },
    {
      name: t('价格'),
      key: '1',
      hideDirection: false,
      sortDirection: 'DESC', // DESC=降序，ASC=升序
      cloudProductSort: [2, 3],
    },
    {
      name: t('销量'),
      key: '2',
      hideDirection: false,
      sortDirection: 'DESC',
      cloudProductSort: [4, 5],
    },
    {
      name: t('销售单数'),
      key: '4',
      hideDirection: false,
      sortDirection: 'DESC',
      cloudProductSort: [],
    },
    {
      name: t('最新上架时间'),
      key: '5',
      hideDirection: false,
      sortDirection: 'DESC',
      cloudProductSort: [6],
    },
    {
      name: t('货名'),
      key: '6',
      hideDirection: false,
      sortDirection: 'DESC',
      cloudProductSort: [7],
    },
  ]

  return SORT_OPTIONS
}

export default {
  IMAGE_DEFAULT: productDefault,
  VIDEO_DEFAULT: productDefault,
  THUMB_SIZE: 140, // 货品主图原图压缩尺寸
  VIDEO_SNAPSHOT_SIZE: 100, // 货品视频截帧尺寸
  DELAY: 10000, // 轮询锁执行间隔时间，单位为毫秒
  DEFAULT_TAB,
  getSortOptions,
  REQUEST_EXPIRED: t('请求已过期'),
}
